exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-00b47b08]{color:#000}.card[data-v-00b47b08]{height:100%;background-image:linear-gradient(180deg,transparent,transparent,rgba(0,0,0,.07));border:1px solid rgba(0,0,0,.2);border-radius:.8rem}.nav-pills .nav-link.active[data-v-00b47b08],.nav-pills .show>.nav-link[data-v-00b47b08]{color:var(--btntxt1);background-color:var(--btnbg1)}", ""]);

// exports
